module.exports = __webpack_public_path__ + "img/carshinaused_05.00caa934.jpg";